import React, { useContext } from "react";
import { ProductContext } from "../../context/ProductContext";

const IndustrialFields: React.FC = () => {
  const context = useContext(ProductContext);

  if (!context?.product) return null;

  const {
    dimensions,
    powerSource,
    capacity,
    safetyStandards,
    maintenance,
    headingColor,
    textColor,
    headingFontStyle,
    fontStyle
  } = context.product;

  return (
    <>
      {dimensions && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Dimensions
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {dimensions}
          </p>
        </div>
      )}
      {powerSource && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Power Source
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {powerSource}
          </p>
        </div>
      )}
      {capacity && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Capacity
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {capacity}
          </p>
        </div>
      )}
      {safetyStandards && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Safety Standards
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {safetyStandards}
          </p>
        </div>
      )}
      {maintenance && (
        <div className="w-full max-w-2xl mx-auto px-4 mb-5 font-mulish text-left">
          <h2
            style={{ letterSpacing: "0.01em", color: headingColor || "#000000", fontFamily: headingFontStyle }}
            className="text-base font-bold leading-tight pb-2"
          >
            Maintenance
          </h2>
          <p style={{ color: textColor, fontFamily: fontStyle }} className="text-sm mt-1 leading-snug">
            {maintenance}
          </p>
        </div>
      )}
    </>
  );
};

export default IndustrialFields;
